export default [
  {
    path: '/main/reportactivemovement',
    meta: {
      tag: 'report_activemovement',
      name: 'Histórico de Movimentação de Ativos',
      breadcrumb: 'Histórico de Movimentação de Ativos'
    },
    component: () => import(/* webpackChunkName: "report-activemovement" */ '@/views/main/reports/activemovement/Index.vue'),
    children: [
      {
        path: '',
        name: 'listactivemovement',
        meta: {
          tag: 'report_activemovement',
          menu: 'reports',
          name: 'Histórico de Movimentação de Ativos'
        },
        component: () => import(/* webpackChunkName: "report-activemovement" */ '@/views/main/reports/activemovement/List.vue'),
      },
      {
        path: '/main/reportactivemovement/add',
        name: 'addactivemovement',
        meta: {
          tag: 'add_activemovement',
          menu: 'reports',
          name: 'Adicionar | Histórico de Movimentação de Ativo',
          breadcrumb: 'Adicionar Histórico de Movimentação de Ativo'
        },
        component: () => import(/* webpackChunkName: "report-activemovement-add" */ '@/views/main/reports/activemovement/Add.vue')
      },
    ]
  }
]  